import { Text } from '@uhg-abyss/web/ui/Text';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Box } from '@uhg-abyss/web/ui/Box';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import React, { useState } from 'react';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export type SaveFavoritePanelProps = {
  storedFolders: string[];
  onCreateFolder: (folderName: string) => void;
  onSave: (folder: string) => void;
  onCancel: () => void;
};

export const SaveFavoritePanel = ({
  storedFolders,
  // NOTE - There should be either a separate callback, or parameters for this callback
  // to indicate the difference between creating a new folder and saving to an existing folder.
  onSave,
  onCancel,
}) => {
  const [folderName, setFolderName] = useState<string>('');

  const menuItems = storedFolders.map((folder) => ({
    title: folder,
    onClick: () => {
      setFolderName(folder);
    },
  }));

  return (
    <div style={{ margin: '10px' }}>
      <Box>
        <Flex justify="space-evenly">
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Text fontWeight="bold" color="$core.color.neutral.100">Save in</Text>
              <div style={{ display: 'inline-block', border: '1px solid #949494', borderRadius: 4, overflow: 'hidden' }}>
              <DropdownMenu
                outline={true}
                label="Select"
                menuItems={menuItems}
                isDisabled={storedFolders.length === 0}
                css={{
                  'abyss-button-root': { borderRadius: 4 },
                  'abyss-dropdown-menu-trigger-root': { borderRadius: 4, border: 'none' },
                }}
              />
              </div>
            </div>
          </div>
          <Text
            color="black"
            fontWeight="bold"
            fontSize="md"
            style={{ alignItems: 'center', display: 'flex' }}
          >
            OR
          </Text>
          <div>
            <TextInput
              label={<strong style={{ color: 'black' }}>Create a new folder</strong>}
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              onClear={() => setFolderName('')}
            />
          </div>
        </Flex>
        {storedFolders.length === 0 && (
          <Text
            color="red"
            fontSize="sm"
          >
            You have no saved folders. Please create a new folder
          </Text>
        )}
        <br />
        To find your saved favorites, click "My favorites" in the hamburger menu
        on any page
        <div style={{ display: 'flex', gap: '10px', marginTop: 15 }}>
          <Button
            data-cy="fav-cancel-button"
            onClick={onCancel}
            variant="outline"
          >
            Cancel
          </Button>
          <Button
            data-cy="fav-save-button"
            onClick={() => {
              onSave(folderName);
            }}
            isDisabled={!folderName.trim()}
          >
            Save
          </Button>
        </div>
      </Box>
    </div>
  );
};
